module.exports = __webpack_public_path__ + "static/media/gcdef_10036.a885d31a.ico";